.tracking-number-link{color:#2196f3;text-decoration:underline;cursor:pointer;margin-bottom:0}
/*# sourceMappingURL=table-tracking-number-cell.component-L4MLD75N.css.map */
